import { IRectangleCoordinatableObject } from "../../../../../domain/editableFormat/objects";
import { IRectangleCoordinatableObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { ObjectTranslator } from "./base";

export class NotImplementedObjectTranslator extends AbstractObjectTranslator<IRectangleCoordinatableObject, IRectangleCoordinatableObjectBean> {
  constructor() {
    super(new ObjectTranslator());
  }

  overwriteObject(source: IRectangleCoordinatableObject, bean: IRectangleCoordinatableObjectBean, formatId: number): void {
    // とりあえず配置できるよう強制的に矩形座標系として扱う.
    source.location = {
      x: 0,
      y: 0,
    };
    source.size = {
      width: 20,
      height: 20,
    };
  }

  overwriteBean(source: IRectangleCoordinatableObjectBean, object: IRectangleCoordinatableObject): void {
    // 登録まではケアしない.(無理やり登録しても意味ないので.)
  }
}
